<template>
<div class="chapter">
<div class="inner_page">
<div class="dedication" id="dedication">
<h2 class="dedicationText"><em class="italic">Dedicated to My wife April, my boys, Richard and Nicholas, and all my brothers in The Corps.</em></h2>
<p class="centerImage" id="nick"><img alt="Image" src="images/img5.jpg"/></p>
<p class="caption">Gunny Sergeant Nick Popaditch with wife April enjoying a night out prior to his deployment in 2004 (Operation Iraqi Freedom 2). “We both knew I was going, but only I knew I had volunteered to go back.”</p>
<p class="caption1"><em class="italic">Popaditch Family</em></p>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// OnceAMarine_dedication.vue?5ebc444a